import { render, staticRenderFns } from "./DeliveryComponent.vue?vue&type=template&id=655d08f8&scoped=true"
import script from "./DeliveryComponent.vue?vue&type=script&lang=js"
export * from "./DeliveryComponent.vue?vue&type=script&lang=js"
import style0 from "./DeliveryComponent.vue?vue&type=style&index=0&id=655d08f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d08f8",
  null
  
)

export default component.exports